//@flow
import {connect} from 'react-redux';
import {CommonActions} from '@react-navigation/native';
import SuspendSwapTerminateSuccess from './SuspendSwapTerminateSuccess.container';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';
import {customerEmailSelector} from '../../modules/Customer/selectors';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import Navigation from '../../lib/navigation';

import type {
  StateProps,
  DispatchProps,
} from '../../components/SuccessPage/SuccessPage';
import type {StateType} from '../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  successImage: theme.successPhoneImage,
  successTitle: I18n.t('Dashboard.LostAndStolen.suspensionSuccessTitle', {
    customerEmail: customerEmailSelector(state),
  }),
  confirmButtonText: I18n.t('Dashboard.LostAndStolen.confirmButton'),
  isInitializingSignUp: isLoadingSelector(state, 'initSignUp'),
  secondaryButtonText: I18n.t('Dashboard.LostAndStolen.orderReplacementSim'),
  orderEsimButtonText: I18n.t('Dashboard.LostAndStolen.orderReplacementESim'),
  actionType: 'suspendLine',
});

const mapDispatchToProps = dispatch => ({
  onSecondaryButtonPress: () => {
    Navigation.dispatch(
      CommonActions.navigate('connected', {
        screen: 'stack',
        params: {screen: 'simReplacement'},
      }),
    );
  },
  onInitEsimReplacement: () => {
    Navigation.dispatch(
      CommonActions.navigate('connected', {
        screen: 'stack',
        params: {screen: 'eSimReplacement'},
      }),
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuspendSwapTerminateSuccess);
